import { createFileRoute } from "@tanstack/react-router";
import { DeFiPage } from "../../features/defi/pages/defi-page";

export const Route = createFileRoute("/_layout/defi")({
  component: DeFiPage,
});
